import PropTypes from 'prop-types';
import ImageProp from './imageProp';
import JourneyStepProp from './journeyStepProp';

const propType = {
  _id: PropTypes.string,
  isPublic: PropTypes.bool,
  slug: PropTypes.string,
  title: PropTypes.string,
  summary: PropTypes.string,
  description: PropTypes.string,
  motivation: PropTypes.string,
  image: PropTypes.oneOfType([
    PropTypes.shape(ImageProp.propType),
    PropTypes.string,
  ]),
  targetUsers: PropTypes.arrayOf(PropTypes.string),
  journeyDefault: PropTypes.bool,
  isDefault: PropTypes.bool,
  isSequential: PropTypes.bool,
  steps: PropTypes.arrayOf(PropTypes.shape(JourneyStepProp.propType)),
  previews: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType)),
  inAppProduct: PropTypes.shape({ price: PropTypes.number.isRequired }),
  inAppPromotion: PropTypes.shape({ price: PropTypes.number.isRequired }),
};

export default { propType };
